"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLoginAvailabilityDto = instanceOfLoginAvailabilityDto;
exports.LoginAvailabilityDtoFromJSON = LoginAvailabilityDtoFromJSON;
exports.LoginAvailabilityDtoFromJSONTyped = LoginAvailabilityDtoFromJSONTyped;
exports.LoginAvailabilityDtoToJSON = LoginAvailabilityDtoToJSON;
exports.LoginAvailabilityDtoToJSONTyped = LoginAvailabilityDtoToJSONTyped;
/**
 * Check if a given object implements the LoginAvailabilityDto interface.
 */
function instanceOfLoginAvailabilityDto(value) {
    return true;
}
function LoginAvailabilityDtoFromJSON(json) {
    return LoginAvailabilityDtoFromJSONTyped(json, false);
}
function LoginAvailabilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
    };
}
function LoginAvailabilityDtoToJSON(json) {
    return LoginAvailabilityDtoToJSONTyped(json, false);
}
function LoginAvailabilityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'phone': value['phone'],
        'email': value['email'],
    };
}
